import type { IncidentSeverity, ServiceStatus } from "../api/status";

const SERVICE_LABELS: Record<ServiceStatus, string> = {
  operational: "Operational",
  degraded: "Degraded performance",
  partial_outage: "Partial outage",
  major_outage: "Major outage",
  unknown: "Unknown",
};

const SERVICE_DOT: Record<ServiceStatus, string> = {
  operational: "bg-status-ok",
  degraded: "bg-status-degraded",
  partial_outage: "bg-status-partial",
  major_outage: "bg-status-major",
  unknown: "bg-status-unknown",
};

export function ServiceStatusBadge({ status }: { status: ServiceStatus }): JSX.Element {
  return (
    <span className="pill bg-bg-elevated text-text-secondary">
      <span className={`h-2 w-2 rounded-full ${SERVICE_DOT[status]}`} />
      {SERVICE_LABELS[status]}
    </span>
  );
}

const SEVERITY_LABELS: Record<IncidentSeverity, string> = {
  degraded: "Degraded",
  partial: "Partial outage",
  major: "Major outage",
};

const SEVERITY_TONE: Record<IncidentSeverity, string> = {
  degraded: "bg-status-degraded/15 text-status-degraded",
  partial: "bg-status-partial/15 text-status-partial",
  major: "bg-status-major/15 text-status-major",
};

export function IncidentSeverityBadge({ severity }: { severity: IncidentSeverity }): JSX.Element {
  return <span className={`pill ${SEVERITY_TONE[severity]}`}>{SEVERITY_LABELS[severity]}</span>;
}
